import React from "react";
import Marquee from "react-fast-marquee";

const items = [
  "Social Networking",
  "Business CRM",
  "Healthcare",
  "Fintech",
  "Food Delivery",
  "Travel & Booking",
  "E-commerce",
  "AI Tools",
];

const Star = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" className="inline-block mx-6 -mt-2">
    <path
      d="M14 0 L17 11 L28 14 L17 17 L14 28 L11 17 L0 14 L11 11 Z"
      fill="#2544EE"
    />
  </svg>
);

const MarqueeRibbon = () => {
  return (
    <section
      data-testid="marquee-ribbon"
      className="relative border-y border-ink bg-ink py-6 md:py-8"
    >
      <Marquee gradient={false} speed={42} pauseOnHover>
        {items.map((it, i) => (
          <span
            key={i}
            className="font-display text-4xl md:text-6xl font-extrabold uppercase tracking-tightest text-cream"
          >
            <span className="mx-8">{it}</span>
            <Star />
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default MarqueeRibbon;